// extracted by mini-css-extract-plugin
module.exports = {"main":"_3Mw7n","bottomInset":"_3_hbS","wide":"_2LWh2","medium":"_1Iv0S","small":"_3jV4T","aside":"_2zsI2","section":"_27hwt","rightSide":"_2Hc8i","fadeContainer":"_3qPdJ"};